// The pools a value is built out of that do not change with where the record is from. A company called Vertex and a
// file called `report.pdf` read the same in every locale here, where a name and a street do not — which is the whole
// of why these are not in `locales.ts` and every list there is not in this one.

// Latin rather than English: a paragraph of real sentences gets read, and what is wanted from filler text is that
// nobody reads it. Every word here is from the passage everybody's filler text is from.
export const LOREM = [
  "lorem",
  "ipsum",
  "dolor",
  "sit",
  "amet",
  "consectetur",
  "adipiscing",
  "elit",
  "sed",
  "do",
  "eiusmod",
  "tempor",
  "incididunt",
  "ut",
  "labore",
  "et",
  "dolore",
  "magna",
  "aliqua",
  "enim",
  "ad",
  "minim",
  "veniam",
  "quis",
  "nostrud",
  "exercitation",
  "ullamco",
  "laboris",
  "nisi",
  "aliquip",
  "ex",
  "ea",
  "commodo",
  "consequat",
  "duis",
  "aute",
  "irure",
  "in",
  "reprehenderit",
  "voluptate",
  "velit",
  "esse",
  "cillum",
  "eu",
  "fugiat",
  "nulla",
  "pariatur",
  "excepteur",
  "sint",
  "occaecat",
  "cupidatat",
  "non",
  "proident",
  "sunt",
  "culpa",
  "qui",
  "officia",
  "deserunt",
  "mollit",
  "anim",
  "id",
  "est",
  "laborum",
];

export const COMPANY_STEMS = [
  "Nova",
  "Vertex",
  "Lumen",
  "Aurora",
  "Quantum",
  "Apex",
  "Orbit",
  "Cobalt",
  "Zenith",
  "Delta",
  "Helix",
  "Pinnacle",
  "Summit",
  "Beacon",
  "Cipher",
  "Kestrel",
  "Meridian",
  "Solstice",
  "Onyx",
  "Prism",
  "Atlas",
  "Ember",
  "Fathom",
  "Harbour",
  "Ironwood",
  "Juniper",
  "Lattice",
  "Monarch",
  "Northgate",
  "Opal",
  "Quarry",
  "Redwood",
];

export const JOB_TITLES = [
  "Software Engineer",
  "Product Manager",
  "Data Analyst",
  "Designer",
  "Site Reliability Engineer",
  "Technical Writer",
  "Account Executive",
  "Operations Manager",
  "Research Scientist",
  "Support Engineer",
  "Security Analyst",
  "Finance Controller",
  "Marketing Lead",
  "Recruiter",
  "Solutions Architect",
  "Quality Engineer",
  "Database Administrator",
  "Project Coordinator",
  "Business Analyst",
  "Systems Engineer",
];

export const PRODUCT_ADJECTIVES = [
  "Compact",
  "Wireless",
  "Insulated",
  "Adjustable",
  "Rechargeable",
  "Folding",
  "Stainless",
  "Portable",
  "Reinforced",
  "Lightweight",
  "Waterproof",
  "Modular",
];

export const PRODUCT_NOUNS = [
  "Keyboard",
  "Lamp",
  "Backpack",
  "Kettle",
  "Monitor",
  "Chair",
  "Bottle",
  "Headphones",
  "Notebook",
  "Charger",
  "Speaker",
  "Toolkit",
  "Mouse",
  "Stand",
  "Cable",
  "Bag",
];

export const DEPARTMENTS = [
  "Engineering",
  "Sales",
  "Marketing",
  "Finance",
  "Operations",
  "People",
  "Legal",
  "Support",
  "Research",
  "Design",
];

// The values a `status` column actually holds, which is a short closed list wherever it appears.
export const STATUSES = ["active", "pending", "suspended", "archived", "draft", "published", "cancelled", "complete"];

export const COLOUR_NAMES = [
  "red",
  "orange",
  "amber",
  "green",
  "teal",
  "cyan",
  "blue",
  "indigo",
  "violet",
  "magenta",
  "brown",
  "grey",
  "black",
  "white",
];

export const MIME_TYPES = [
  "application/json",
  "application/pdf",
  "text/csv",
  "text/plain",
  "text/html",
  "image/png",
  "image/jpeg",
  "image/svg+xml",
  "video/mp4",
  "audio/mpeg",
  "application/zip",
  "application/octet-stream",
];

export const FILE_EXTENSIONS = ["pdf", "csv", "json", "png", "jpg", "txt", "docx", "xlsx", "zip", "md", "svg", "log"];

// A tz database name rather than an offset: an offset is a fact about one instant and a zone is a fact about a place.
export const TIMEZONES = [
  "UTC",
  "Europe/London",
  "Europe/Berlin",
  "Europe/Paris",
  "Europe/Madrid",
  "Europe/Rome",
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "America/Sao_Paulo",
  "Asia/Tokyo",
  "Asia/Shanghai",
  "Asia/Kolkata",
  "Australia/Sydney",
  "Africa/Lagos",
];

export const LANGUAGE_TAGS = [
  "en-US",
  "en-GB",
  "de-DE",
  "fr-FR",
  "es-ES",
  "it-IT",
  "ja-JP",
  "pt-BR",
  "nl-NL",
  "sv-SE",
  "pl-PL",
  "zh-CN",
];

// What a made-up host sits under: RFC 2606's three names and its `.example`, and RFC 6761's `.test`.
export const RESERVED_DOMAINS = ["example.com", "example.net", "example.org", "example", "test"];

// The four the mail providers actually are, for the addresses meant to look like somebody's personal one.
export const MAIL_DOMAINS = ["example.com", "example.org", "example.net", "test.example"];

export const USER_AGENTS = [
  "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0 Safari/537.36",
  "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/17.4 Safari/605.1.15",
  "Mozilla/5.0 (X11; Linux x86_64; rv:125.0) Gecko/20100101 Firefox/125.0",
  "Mozilla/5.0 (iPhone; CPU iPhone OS 17_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148",
  "Mozilla/5.0 (Linux; Android 14; Pixel 8) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0 Mobile Safari/537.36",
];

export const HTTP_METHODS = ["GET", "POST", "PUT", "PATCH", "DELETE", "HEAD", "OPTIONS"];

// The codes a log or a fixture is actually made of, weighted by nothing: a batch wants the unusual ones to appear.
export const HTTP_STATUSES = [200, 201, 202, 204, 301, 302, 304, 400, 401, 403, 404, 409, 422, 429, 500, 502, 503];

export const CURRENCIES = ["USD", "EUR", "GBP", "JPY", "CHF", "CAD", "AUD", "SEK", "NOK", "DKK", "PLN", "BRL"];
